export enum CoffeeAppType {
  CRM = "crm",
  CRM_GRADER = "crm_grader",
}
